/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { overflowEllipsis, fixedFlexItem } from 'src/styles/mixins';

export const RemoveReviewerButton = styled(Button)({
  '> span': {
    '&:hover, &:focus': {
      color: token('color.text.danger', colors.DN0),
    },
  },
  display: 'none',
  '&&': {
    marginRight: `${token('space.050', '4px')}`,
    borderRadius: '50%',
  },
});

export const NameWrapper = styled.span(
  {
    marginLeft: '4px',
  },
  overflowEllipsis()
);

/* stylelint-disable a11y/media-prefers-reduced-motion */

export const ReviewerStatusContainer = styled.div<{
  canRemoveReviewer?: boolean;
}>(
  {
    display: 'flex',
    alignItems: 'center',
    padding: `${token('space.050', '4px')} 0`,
    transition: 'all 0.1s ease-out',
  },
  props =>
    props.canRemoveReviewer && {
      '&:hover, &:focus, &:focus-within': {
        backgroundColor: token('color.background.neutral', colors.N30),
        borderRadius: `${token('border.radius', '3px')}`,
        [`${RemoveReviewerButton}`]: {
          display: 'flex',
        },
      },
    }
);

export const BackgroundContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minWidth: 0,
});

export const IconWrapper = styled.span(
  {
    marginLeft: `${token('space.050', '4px')}`,
  },
  fixedFlexItem
);

export const UserAvatarWrapper = styled.span(fixedFlexItem);

export const SpinnerContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
});
